import { render } from "./VideoPanel.vue?vue&type=template&id=5f5573ce&scoped=true"
import script from "./VideoPanel.vue?vue&type=script&lang=js"
export * from "./VideoPanel.vue?vue&type=script&lang=js"

import "./VideoPanel.vue?vue&type=style&index=0&id=5f5573ce&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5573ce"]])

export default __exports__